module.exports = __webpack_public_path__ + "static/game1-362b1239de7871a171432c25bee805b8.gif";